<div class="sign-in-expanded"
    [hidden]="hide">
    <div *ngIf="!isLoading" class="content only-button">
        <app-box-arrow [colorChange]="true"></app-box-arrow>
        <!-- <div class="status-box" *ngIf="!signed">
            <span class="daily-text">今日还未签到</span>
        </div>
        <div class="status-box finished" *ngIf="signed">
            <span class="daily-text">今日已经签过到了哦！</span>
            <span class="daily-text">
            </span>
        </div>
        <div class="button-box">
            <div *ngIf="!signed" (click)="openSignIn()" class="open-sign-button">去签到</div>
            <div *ngIf="signed" (click)="openSignIn()" class="open-sign-button">查看签到规则></div>
        </div> -->
        <div class="button-box justify-around">
            <div class="button-block" (click)="openSignIn()">
                <img class="button-icon" src="{{'./assets/images/daily-sign-in/signIn.png' | absUrl}}">
                <span class="button-text">每日签到</span>
            </div>
            <div class="button-block" (click)="navTo('daily_quest')">
                <img class="button-icon" src="{{'./assets/images/daily-sign-in/quest.png' | absUrl}}">
                <span class="button-text">日常任务</span>
            </div>
            <!-- <div class="button-block" (click)="navTo('inv_welfare')">
                <span class="button-text">邀请福利</span>
            </div> -->
        </div>
    </div>
    <div *ngIf="isLoading" class="loader-content">
        <app-loader-spinner></app-loader-spinner>
    </div>
</div>
